"use client";

import { XcutiqStudioTargetBridge } from "./xcutiq-studio-target-bridge";

export function XcutiqStudioRemoteHost() {
  return <XcutiqStudioTargetBridge enabled controllerUrl="https://studio.xcutiq.com" targetId="ai-fabric-user" />;
}
